module.exports = __webpack_public_path__ + "img/share_ico4.eec98b18.png";